import { inject, Pipe, PipeTransform } from '@angular/core';

import { SurveyEditorService } from '../services/survey-editor.service';

@Pipe({
  name: 'qCode',
  pure: false
})
export class QuestionCodePipe implements PipeTransform {
  private surveyEditorService = inject(SurveyEditorService);

  transform(qId: string): string {
    const surveyEditor = this.surveyEditorService.surveyEditor$();
    const question = surveyEditor?.questions.find((q) => q.id === qId) ?? surveyEditor?.questionsHidden.find((q) => q.id === qId);

    if (question) {
      return question.code;
    }
  }
}
